<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      border-card
      health-package-details
    "
  >
    <!-- <div class="Head-div p-3 border-bottom">
      <h4 class="mb-0">Package Name</h4>
    </div> -->
    <div class="p-3">
      <div
        v-if="healthPackageDetails && healthPackageDetails.health_package"
        class="health-package-card-main"
      >
        <div class="card-head d-just-space d-align p-3">
          <div>
            <h4 class="mt-0 mb-1 text-white">
              {{ healthPackageDetails.health_package.name }}
            </h4>
            <h6 class="m-0 text-white">
              {{ healthPackageDetails.health_package.health_package_type }}
            </h6>
          </div>
          <div class="text-right">
            <div v-if="healthPackageDetails.health_package.payable_amount > 0" class="d-align flex-end">
              <p class="text-white mb-1 mr-2">
                <strike
                  >&#8377;
                  {{ healthPackageDetails.health_package.total_cost }}</strike
                >
              </p>
              <h4 class="text-white m-0">
                <b
                  >&#8377;
                  {{ healthPackageDetails.health_package.payable_amount }}</b
                >
              </h4>
            </div>
            <h5 v-else class="text-white m-0">
              FREE
            </h5>
          </div>
        </div>
        <div class="card-text p-3 pb-0">
          <div
            v-if="healthPackageDetails.health_package.advice"
            class="d-flex i-con"
          >
            <div class="mr-2 mt-1">
              <InfoIconSVG class="w-1" />
            </div>
            <p>
              {{ healthPackageDetails.health_package.advice }}
              <b v-if="healthPackageDetails.health_package.is_fasting"
                >Fasting is Required</b
              >
            </p>
          </div>
          <!-- ................................ -->
          <div class="m-row">
            <CCard
              v-if="
                healthPackageDetails &&
                healthPackageDetails.health_package &&
                healthPackageDetails.health_package.tests
              "
              class="border-radius-0 mb-0 border-left-0 border-right-0"
            >
              <CCardHeader class="d-just-space d-align border-0">
                <h5 class="m-0">
                  Number of test(s)
                  <b>{{ healthPackageDetails.health_package.tests.length }}</b>
                </h5>
                <div @click="cardCollapseFunc()" class="cursor">
                  <downArrowSVG class="collaps-arrow" />
                </div>
              </CCardHeader>
              <CCollapse :show="cardCollapse">
                <CCardBody class="pt-0">
                  <div class="package-test">
                    <ul
                      v-for="(
                        test, i
                      ) in healthPackageDetails.health_package.tests.map(
                        (_) => _
                      )"
                      :key="i"
                      class="d-flex flex-wrap mb-0"
                    >
                      <li>{{ test.test_name }}</li>
                    </ul>
                  </div>
                </CCardBody>
              </CCollapse>
            </CCard>
          </div>
          <!-- ................................ -->
          <div class="d-just-space my-4">
            <div
              v-if="
                healthPackageDetails.center &&
                healthPackageDetails.center.owner &&
                healthPackageDetails.center.owner.first_last_name
              "
            >
              <h5 class="mb-0">
                Owner Details -
                <b>{{ healthPackageDetails.center.owner.first_last_name }}</b>
              </h5>
            </div>
            <div>
              <h5 class="mb-0">
                Contact number -
                <b>{{ healthPackageDetails.center.contact_number }}</b>
              </h5>
            </div>
          </div>
        </div>
        <div class="health-card-footer d-just-space p-3">
          <div v-if="healthPackageDetails.health_package.home_service && healthPackageDetails.center.home_service">
            <h5 class="m-0">
              <b> Home service available</b>
              <span
                v-if="healthPackageDetails.center.service_area == 5"
                class="font-sm ml-3 font-weight-bold"
                >Upto 5 KM</span
              >
              <span
                v-else-if="healthPackageDetails.center.service_area == 10"
                class="font-sm ml-3 font-weight-bold"
                >Upto 10 KM</span
              >
              <span
                v-else-if="healthPackageDetails.center.service_area == 100"
                class="font-sm ml-3 font-weight-bold"
                >More than 10 KM</span
              >
            </h5>
          </div>
          <div class="">
            <h5 class="m-0">
              Status -
              <b class="text-sucess">{{
                healthPackageDetails.health_package.is_deleted
                  ? "Deleted"
                  : healthPackageDetails.health_package.is_active
                  ? "Active"
                  : "Deactive"
              }}</b>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/main.js";
import { pickSvg } from "@/views/SVG";

export default {
  components: {
    ...pickSvg("InfoIconSVG", "downArrowSVG"),
  },
  mounted() {
    this.healthPackageDetails = this.$route.query.healtpackage;
  },
  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: false,
        to: "/",
      },
      {
        text: "Health Packages",
        disabled: false,
        to: "/health-package",
      },
      {
        text: "Health Package Details",
        disabled: true,
        to: "",
      },
    ]);
  },
  data() {
    return {
      cardCollapse: false,
      cardCollapses: false,
      isOpen: false,
      isOpenCollaps: false,
      healthPackageDetails: "",
    };
  },
  methods: {
    cardCollapseFunc() {
      if (!this.isOpenCollaps) {
        this.isOpenCollaps = true;
        this.cardCollapse = !this.cardCollapse;
        var x = (document.getElementsByClassName(
          "collaps-arrow"
        )[0].style.transform = "rotate(180deg)");
      } else {
        this.isOpenCollaps = false;
        this.cardCollapse = !this.cardCollapse;
        ("rotate(0deg)");
      }
    },
    cardCollapseFun() {
      if (!this.isOpen) {
        this.isOpen = true;
        this.cardCollapses = !this.cardCollapses;
        var x = (document.getElementsByClassName(
          "collaps-arrow"
        )[1].style.transform = "rotate(180deg)");
      } else {
        this.isOpen = false;
        this.cardCollapses = !this.cardCollapses;
        document.getElementsByClassName("collaps-arrow")[1].style.transform =
          "rotate(0deg)";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.health-package-card-main {
  margin-bottom: 1.5rem;
  border: 1px solid #eee;
  border-radius: 4px;
  .m-row {
    margin: 0 -1rem;
  }
  .card-head {
    background-color: #01a09b;
    border-radius: 4px;
  }
  li {
    font-size: 1rem;
    &::marker {
      font-size: 1rem;
    }
  }
  .card-text {
    .i-con {
      svg {
        path,
        circle {
          stroke: #c7465d;
        }
        rect {
          fill: #c7465d;
        }
      }
    }
    .package-test {
      ul {
        padding-left: 16px;
        li {
          width: 25%;
          padding-right: 1.5rem;
        }
      }
    }
    .card-header {
      svg {
        width: 1.2rem;
      }
    }
  }
  .health-card-footer {
    h5 {
      b {
        &.text-sucess {
          color: #01a09b;
        }
      }
    }
  }
}
</style>